<!-- Breadcrumb -->
<div class="content-breadcrumb div-breadcrumb">
  <div class="row">
    <div class="col">
      <em class="fa fa-address-card-o icon-breadcrumb"></em>
      <span class="text-breadcrumb">Atendimentos</span>
    </div>

    <div class="col-auto">
      <a type="button" class="btn btn-outline-primary float-right mr-2" href="{{urlManual}}" download>
        <i class="fa fa-info-circle"></i> &nbsp; Ajuda
      </a>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="row mt-4">
    <div class="col mb-1">
      <form class="form-inline" (ngSubmit)="buscarGuiasMedicas()" #filterForm="ngForm" autocomplete="off">
        <div class="row">
          <div class="col-3 ps-3 pt-0 pe-1 pb-0">
            <input class=" form-control" type="text" placeholder="Código Guia" name="id" [(ngModel)]="filters.id">
          </div>
          <div class="col-3 ps-1 pt-0 pe-1 pb-0">
            <input class="form-control" type="text" placeholder="Nome" name="beneficiado" [(ngModel)]="filters.beneficiado">
          </div>
          <div class="col-3 ps-1 pt-0 pe-1 pb-0">
            <input class="form-control" type="text" mask="000.000.000-00" placeholder="CPF" name="cpf" [(ngModel)]="filters.cpf">
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-3 ps-3 pt-0 pe-1 pb-0">
            <input class="form-control mr-sm-2" placeholder="Período" bsDaterangepicker
            (bsValueChange)="setPeriodDateFilter($event)"
            [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', adaptivePosition: true, containerClass: 'theme-dark-blue', selectFromOtherMonth: true, showWeekNumbers: false }" />
          </div>
          <div class="col-3 ps-1 pt-0 pe-1 pb-0">
            <button type="submit" class="btn btn-outline-primary rounded"><i class="fa fa-search"></i> Buscar</button>
          </div>
        </div>
      </form>
    </div>

    <div class="col-auto mb-1">
      <button type="button" class="btn btn-primary float-right" routerLink="/atendimentos/new">
        <i class="fa fa-plus"></i> &nbsp; Atendimento
      </button>
    </div>
  </div>

  <app-card titleCard="Lista de guias cadastradas">
    <div class="table-responsive">
      <table class="table table-bordered table-hover text-center text-table">
        <!-- Table head -->
        <thead>
          <tr class="table-active">
            <th style="width: 75px">Cód</th>
            <th style="width: 120px">CPF Titular</th>
            <th>Beneficiado</th>
            <th>Prestador</th>
            <th style="width: 150px">Usuário</th>
            <th style="width: 150px">Atendimento</th>
            <th style="width: 90px">Ações</th>
          </tr>
        </thead>
        <tbody>
          <ng-template ngFor let-guia
            [ngForOf]="listaGuiasMedicas | paginate: { currentPage: pageable.page, itemsPerPage: pageable.size, totalItems : pageable.totalElements }">
            <tr>
              <th>{{ guia.id }}</th>
              <td>{{ guia.cpfTitular | cpf }}</td>
              <td>{{ guia.beneficiado }}</td>
              <td>{{ guia.prestador?.nome }}</td>
              <td>{{ guia.usuario.nome }}</td>
              <td>{{ guia.dataAtendimento | date:'dd/MM/yyyy HH:mm:ss' }}</td>
              <td>
                <a *ngIf="!exibirBotoes(guia.finalizado)" data-toggle="tooltip" title="Editar" [routerLink]="['/atendimentos/edit', guia.id]">
                  <em class="fa fa-edit icon-table"></em>
                </a>&nbsp;
                <a data-toggle="tooltip" title="Detalhe" [routerLink]="['/atendimentos/view', guia.id]">
                  <em class="fa fa-eye icon-table"></em>
                </a>&nbsp;
                <a *ngIf="!exibirBotoes(guia.finalizado)" data-toggle="tooltip" title="Excluir" (click)="modalExclusaoGuia(contentDelete, guia.id)">
                  <em class="fa fa-trash icon-table"></em>
                </a>
              </td>
            </tr>
          </ng-template>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-center">
      <pagination-controls [autoHide]="true" [responsive]="true" [previousLabel]="labels.previousLabel"
        [nextLabel]="labels.nextLabel" (pageChange)="pageChanged($event)"></pagination-controls>
    </div>
  </app-card>

  <!-- MODAL DE CONFIRMAÇÃO PARA EXCLUIR A GUIA MÉDICA. -->
  <ng-template #contentDelete let-closed="close" let-dismiss="dismiss">
    <div class="modal-header">
      <div class="container row me-0 pe-0">
        <div class="col">
          <h4 class="modal-title" id="modal-title">Excluir Guia Médica</h4>
        </div>
        <div class="col-auto me-0 pe-0">
          <div class="d-flex justify-content-end">
            <button type="button" class="close" aria-label="Close button" aria-describedby="modal-title"
            (click)="dismiss('click')">
            <span aria-hidden="true">&times;</span>
          </button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <p><strong>Você tem certeza que deseja excluir essa guia médica?</strong></p>
      <span class="text-danger">Esta operação não pode ser desfeita.</span>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" ngbAutofocus (click)="dismiss('click')">Cancelar</button>
      <button type="button" class="btn btn-danger" (click)="excluirGuia(identificadorGuiaExclusao)">Excluir</button>
    </div>
  </ng-template>
</div>
